import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  searchInputContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "end",
  },
  headingTop: {
    paddingTop: '50px',
    fontSize: '35px',
    [theme.breakpoints.down('xs')]: {
      fontSize: '25px',
    }
  },
  headingTopDesktop: {
    display: 'inline-block',
    paddingBottom: '50px',
    fontSize: '35px',
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    }
  },
  headingBottomMobile: {
    display: 'none',
    [theme.breakpoints.down('xs')]: {
      display: 'inline-block',
      paddingBottom: '50px',
      fontSize: '25px'
    }
  },
  searchInput: {
    borderRadius: '45px',
    fontSize: '1.8em',
    fontWeight: '300',
    width: '60%',
    backgroundColor: '#FFFEFA',
    margin: theme.spacing(2, 0, 12),
    [theme.breakpoints.down("xs")]: {
      width: "80%",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: '45px',
    },
  },

  root: {
    '&:hover $notchedOutline': {
      border: `2px solid ${theme.palette.primary.main}`,
    },
  },
  notchedOutline: {
    border: `1px solid ${theme.palette.primary.main}`,
  },

  searchIcon: {
    paddingRight: '10px'
  },
  iconHandler: {
    color: theme.palette.primary.main
  },
  iconCautionHandler: {
    backgroundColor: theme.palette.error.main,
    color: '#FFF'
  },
  addCourseContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 4px',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      justifyContent: 'flex-end',
      padding: '0 12px',
    },
  },
  addCourseIcon: {
    color: theme.palette.secondary.main,
    height: '48px',
    width: '48px',
    '&:hover': {
      color: theme.palette.primary.main,
    }
  },
  addCourseCopy: {
    cursor: 'pointer',
    lineHeight: 1.2,
  },
  coursesFilterContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingBottom: '10px',
  },
  courseSearchContainer: {
    marginBottom: '20px',
    padding: '20px',
    borderRadius: '5px',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'center',
      padding: '15px 15px',
      marginBottom: '20px',
    },
  },
  mostLikedContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '0 4px',
    margin: 0,
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      justifyContent: 'flex-end',
      padding: '0 12px',
      '& .MuiFormControlLabel-label': {
        lineHeight: 1.2,
      },
    },
  },
  mostLikedIconWrapper: {
    height: '48px',
    display: 'flex',
    alignItems: 'center',
  },
  mostLikedIcon: {
    color: theme.palette.secondary.main,
    '&:hover': {
      color: theme.palette.primary.main,
    }
  },
  featuredCourse: {
    border: `2px solid ${theme.palette.primary.main}`
  },
  gridContainer: {
    display: "flex",
    alignItems: "center",
    minHeight: "120px",
    justifyContent: 'space-between',
    [theme.breakpoints.down("xs")]: {
      display: 'block',
      alignItems: "center",
      padding: "0",
      justifyContent: "space-between",
      height: "auto",
    },
  },
  courseInfoContainer: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      alignItems: 'center',
    },
    [theme.breakpoints.down("sm")]: {
      display: 'flex',
      flexDirection: 'column'
    }
  },
  courseAddressChild1: {
    padding: "10px",
    width: "500px",
    [theme.breakpoints.down("sm")]: {
      width: "300px"
    },
    [theme.breakpoints.down("xs")]: {
      width: "auto",
    },
  },
  courseAddressChild2: {
    padding: "10px",
    flexGrow: 1,
    [theme.breakpoints.down("xs")]: {
      width: "auto",
    },
  },
  courseAddressChild3: {
    minWidth: "auto",
    textAlign: "right",
    [theme.breakpoints.down("xs")]: {
      width: "auto",
    },
  },
  courseAddressChild3Admin: {
    display: 'flex',
    width: '300px',
    justifyContent: 'space-between'
  },
  courseLink: {
    cursor: "pointer",
    color: theme.palette.primary.main
  },
  teeBoxTabel: {
    minWidth: "300px",
    maxWidth: "600px",
  },

  scorecardTabel: {
    "& .MuiTableCell-root": {
      border: "2px solid rgba(23, 23, 23)",
      textAlign: "center",
    }
  },
  scorecardHolesCell: {
    fontWeight: "bold !important",
    backgroundColor: theme.palette.primary.main,
    color: "#fff !important",
  },
  scorecardHandicapCell: {
    backgroundColor: "#5C6B63 !important",
    color: "#fff !important",
  },
  scorecardParCell: {
    backgroundColor: theme.palette.primary.main,
    color: "rgba(227, 227, 227) !important",
  },
  spinnerContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '300px'
  },
  fakePlayers: {
    backgroundColor: '#fff'
  },
  courseDetailsNav: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingBottom: '40px'
  },
  courseDetailsInfo: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  courseMapContainer: {
    display: 'flex',
    justifyContent: 'end',
  },
  noCoursesFound: {
    height: '250px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  detailsPaper: {
    [theme.breakpoints.down('xs')]: {
      boxShadow: 'none !important',
      backgroundColor: 'transparent !important',
      padding: '0 !important',
    },
  },

  /* ── Redesigned search page ─────────────────────────── */
  searchHero: {
    padding: theme.spacing(7, 2, 6),
    textAlign: 'center',
    background: 'linear-gradient(150deg, #0F3D2E 0%, #092A1F 100%)',
    borderRadius: 12,
    marginBottom: theme.spacing(4),
    borderBottom: `3px solid ${theme.palette.secondary.main}`,
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(5, 2, 4),
    },
  },
  searchHeroEyebrow: {
    color: theme.palette.secondary.light,
    fontWeight: 700,
    fontSize: '0.85rem',
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
    marginBottom: theme.spacing(1.5),
  },
  searchHeroTitle: {
    fontWeight: 800,
    lineHeight: 1.2,
    color: '#F7F4EC',
    marginBottom: theme.spacing(1.5),
    [theme.breakpoints.down('sm')]: { fontSize: '1.9rem' },
  },
  searchHeroSubtitle: {
    color: 'rgba(247, 244, 236, 0.78)',
    fontSize: '1.05rem',
    maxWidth: 560,
    margin: '0 auto',
    lineHeight: 1.7,
    marginBottom: theme.spacing(3.5),
  },
  searchHeroInput: {
    width: '100%',
    maxWidth: 620,
    backgroundColor: '#FFFEFA',
    borderRadius: 45,
    '& .MuiOutlinedInput-root': {
      borderRadius: 45,
      fontSize: '1.05rem',
    },
    '& .MuiOutlinedInput-input': {
      padding: '16px 14px 16px 0',
    },
  },
  quickActions: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(1.5),
    marginTop: theme.spacing(3),
  },
  quickActionChip: {
    fontWeight: 600,
    padding: theme.spacing(0.5, 0.5),
    backgroundColor: 'rgba(247, 244, 236, 0.1)',
    border: '1px solid rgba(247, 244, 236, 0.35)',
    color: '#F7F4EC',
    '& .MuiChip-icon': {
      color: theme.palette.secondary.light,
    },
    '&:hover, &:focus': {
      borderColor: theme.palette.secondary.light,
      backgroundColor: 'rgba(247, 244, 236, 0.18) !important',
    },
  },
  quickActionChipActive: {
    borderColor: theme.palette.secondary.light,
    color: theme.palette.secondary.light,
    backgroundColor: 'rgba(212, 185, 106, 0.15)',
  },
  resultsMeta: {
    color: theme.palette.text.secondary,
    fontSize: '0.88rem',
    margin: theme.spacing(0, 0.5, 2),
  },
  courseCard: {
    borderRadius: 10,
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: 'none',
    padding: theme.spacing(2.5, 3),
    marginBottom: theme.spacing(2),
    transition: 'box-shadow 0.2s, transform 0.2s, border-color 0.2s',
    '&:hover': {
      boxShadow: theme.shadows[4],
      transform: 'translateY(-2px)',
      borderColor: theme.palette.primary.main,
    },
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2),
    },
  },
  courseCardFeatured: {
    borderLeft: `4px solid ${theme.palette.primary.main}`,
  },
  courseCardBody: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
    },
  },
  courseCardInfo: {
    minWidth: 0,
    flex: 1,
  },
  courseCardName: {
    fontWeight: 700,
    fontSize: '1.1rem',
    lineHeight: 1.35,
    marginBottom: theme.spacing(0.5),
  },
  courseCardLocation: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    color: theme.palette.text.secondary,
    fontSize: '0.88rem',
  },
  courseCardChips: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    marginTop: theme.spacing(1.25),
  },
  courseCardActions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flexShrink: 0,
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'space-between',
      marginTop: theme.spacing(1),
    },
  },
  featuredBadge: {
    fontWeight: 700,
    fontSize: 11,
    height: 22,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    marginBottom: theme.spacing(1),
  },
  sectionLabel: {
    fontWeight: 700,
    fontSize: '0.78rem',
    letterSpacing: '0.12em',
    textTransform: 'uppercase',
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(0.75),
  },
  sectionTitle: {
    fontWeight: 700,
    fontSize: '1.3rem',
    marginBottom: theme.spacing(0.5),
  },
  sectionSubtitle: {
    color: theme.palette.text.secondary,
    fontSize: '0.9rem',
    marginBottom: theme.spacing(2.5),
  },
  stateItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(1.25, 1.75),
    borderRadius: 8,
    border: `1px solid ${theme.palette.divider}`,
    textDecoration: 'none',
    color: 'inherit',
    transition: 'background 0.15s',
    '&:hover': {
      background: theme.palette.action.hover,
    },
  },
  stateArrow: {
    fontSize: '0.78rem',
    fontWeight: 600,
    color: theme.palette.primary.main,
  },
  aboutBlock: {
    background: '#EFEBDF',
    borderRadius: 10,
    padding: theme.spacing(4),
    margin: theme.spacing(6, 0, 4),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(3),
    },
  },
  aboutBlockText: {
    color: theme.palette.text.secondary,
    fontSize: '0.95rem',
    lineHeight: 1.75,
    maxWidth: 760,
  },
  searchDivider: {
    margin: theme.spacing(5, 0),
  },
}));
